export const filterOption = (input, option: any) => {
	return (option?.item?.name ?? option?.label ?? '').toLowerCase().includes(input.toLowerCase());
};
